import d3 from '../../globalexports/d3.export';

const removeNoNetworkModal = () => {
  window.setTimeout(() => {
    d3.selectAll('.connectivitymodal').remove();
  }, 0);
};

export { removeNoNetworkModal };
